import { ActivityListState } from '@webinex/activity';
import React, { useContext } from 'react';

export const ActivityOperationStateContext =
  React.createContext<ActivityListState>(undefined!);

export function useActivityOperationState() {
  return useContext(ActivityOperationStateContext);
}
